import React from 'react';

const IsPortraitModal = () => {
  return (
    <div
      className={`fixed top-0 z-10 left-0 right-0 bottom-0  bg-black bg-opacity-[.90] h-[100vh] lg:hidden flex justify-center items-center  w-[100vw] `}
    >
      <div className="w-[90%] h-1/2 bg-white rounded p-10 flex  justify-center items-center">
        <p className="text-4xl font-bebas text-center">
          Please rotate your device to landscape mode for the best
          experience.
        </p>
      </div>
    </div>
  );
};

export default IsPortraitModal;